"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OverflowItem", {
    enumerable: true,
    get: ()=>OverflowItem
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactUtilities = require("@fluentui/react-utilities");
const _useOverflowItem = require("../../useOverflowItem");
const OverflowItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { id , groupId , priority , children  } = props;
    const containerRef = (0, _useOverflowItem.useOverflowItem)(id, priority, groupId);
    return (0, _reactUtilities.applyTriggerPropsToChildren)(children, {
        ref: (0, _reactUtilities.useMergedRefs)(containerRef, ref)
    });
}); //# sourceMappingURL=OverflowItem.js.map

//# sourceMappingURL=OverflowItem.js.map